function checkIsMobile() {
    const isMobileScreen = window.innerWidth < 768;

    const isTouchDevice =
        "ontouchstart" in window || navigator.maxTouchPoints > 0;

    const isMobileDevice =
        /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
            navigator.userAgent.toLowerCase()
        );

    return isMobileScreen || (isMobileDevice && isTouchDevice);
}

export default checkIsMobile;
